var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMercury = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 3.00006C10.6312 3.00006 9.36838 3.46012 8.358 4.23383L6.41714 2.29297L5.00293 3.70718L6.9925 5.69675C6.36541 6.64457 6.00006 7.78021 6.00006 9.00006C6.00006 11.9694 8.16486 14.4398 11.0001 14.9168V17.0001H8.00006V19.0001H11.0001V22.0001H13.0001V19.0001H16.0001V17.0001H13.0001V14.9168C15.8353 14.4398 18.0001 11.9694 18.0001 9.00006C18.0001 7.70554 17.5886 6.50585 16.8895 5.52482L18.7072 3.70718L17.293 2.29297L15.4753 4.1106C14.4943 3.41152 13.2946 3.00006 12.0001 3.00006ZM16.0001 9.00006C16.0001 6.79006 14.2101 5.00006 12.0001 5.00006C9.79006 5.00006 8.00006 6.79006 8.00006 9.00006C8.00006 11.2101 9.79006 13.0001 12.0001 13.0001C14.2101 13.0001 16.0001 11.2101 16.0001 9.00006Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMercury);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mercury.3473f7337e3ca5f93ee34ffc7e8bba4b.svg";